import { ulid } from 'ulid';
export class KeyValues {
    constructor(href, storage, cookies = () => (typeof document === 'undefined' ? '' : document.cookie)) {
        this.href = href;
        this.storage = storage;
        this.cookies = cookies;
        this.kv = {};
    }
    setKeyValue(key, value) {
        this.kv[key] = value;
    }
    setFromConfig(kv) {
        if (!kv)
            return;
        let kvArray = [];
        if (typeof kv === 'string') {
            try {
                kvArray = JSON.parse(kv);
            }
            catch (e) {
                console.warn('Incorrent JSON passed to config.keyvalues');
            }
        }
        if (typeof kv === 'object') {
            kvArray = Object.entries(kv);
        }
        for (let [key, value] of kvArray) {
            this.setKeyValue(key, value);
        }
    }
    getObject(extra = {}) {
        return {
            ...this.kv,
            ...extra,
            dfpPrebid: '2',
            game_name: this.getGameName(),
            arkpromo: this.getArkPromo(),
            utm_campaign: this.getUtmCampaign(),
            ark_affiliate: this.getArkAffiliate(),
            ai_user: this.getAiUser(),
            ai_session: this.getAiSession(),
        };
    }
    getUrlParam(extra = {}) {
        const params = Object.entries(this.getObject(extra)).map(([key, value]) => `${key}=${value ?? ''}`);
        return encodeURIComponent(params.join('&'));
    }
    getPPID() {
        const ppid = this.storage.getItem('_ppid') || ulid();
        this.storage.setItem('_ppid', ppid);
        return ppid;
    }
    getAiUser() {
        const cookies = this.getCookieString();
        const [, id] = cookies.match(/ai_user=(.+?)(;|$)/) || [];
        return id;
    }
    getAiSession() {
        const cookies = this.getCookieString();
        const [, id] = cookies.match(/ai_session=(.+?)(\||;|$)/) || [];
        return id;
    }
    getGameName() {
        const xmlConfig = window.__arkPlayWidget__?.configObj?.config;
        if (xmlConfig)
            return xmlConfig['config-keys']['external-game-id'];
        if (window.__gameData?.slug)
            return window.__gameData.slug;
        const state = window.STORE?.getState();
        if (state)
            return state?.gameArena5Slug || state?.game?.slug;
        return (this.href().match(/games?\/([0-9A-z-]+)/) || [])[1];
    }
    getArkPromo() {
        return this.getFromStorageOrUrl('arkpromo');
    }
    getUtmCampaign() {
        return this.getFromStorageOrUrl('utm_campaign');
    }
    getArkAffiliate() {
        return this.getFromCookie('ark_affiliate');
    }
    getFromStorageOrUrl(key) {
        try {
            const fromLS = this.storage.getItem(key);
            if (fromLS)
                return fromLS;
            const [, fromURL] = this.href().match(new RegExp(`${key}=([0-9A-z_]+)`)) || [];
            if (fromURL) {
                this.storage.setItem(key, fromURL);
                return fromURL;
            }
            return;
        }
        catch (e) {
            return;
        }
    }
    getFromCookie(key) {
        const cookies = this.getCookieString();
        const [, value] = cookies.match(new RegExp(key + '=([^;]*)')) || [];
        return value;
    }
    getCookieString() {
        return typeof this.cookies === 'function' ? this.cookies() : this.cookies;
    }
}
